<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container class="evaluation">
		<v-layout>
			<v-btn @click="openProjectView" class="no-print">
				Podgląd wniosku
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="mr-3 no-print" @click="print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Opinia końcowa</h2>
				<div class="evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa placówki:</strong> {{viewData.agencyName}}
					</div>
					<div>
						<strong class="mr-3">Nazwa projektu:</strong> {{viewData.agencyProjectTitle}}
					</div>
					<div>
						<strong class="mr-3">Numer wniosku:</strong> {{viewData.agencyProjectCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{viewData.controlSum}}
					</div>
					<div class="mt-3">
						<strong class="mr-3">Wnioskowana kwota:</strong> {{formatMoney(viewData.mszFundings)}} {{viewData.currencyCode}}
					</div>
					<div class="mt-3">
						<strong class="mr-3">Kraj:</strong> {{viewData.country}}
					</div>
					<div v-if="viewData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong> {{viewData.extraCountries.join(', ')}}
					</div>
					<div v-if="viewData.author">
						<strong class="mr-3">Autor:</strong> {{viewData.author}}
					</div>
					<div v-if="viewData.firstSendDate">
						<strong class="mr-3">Data pierwszego wysłania:</strong> {{viewData.firstSendDate}}
					</div>
					<div v-if="viewData.latestSendDate">
						<strong class="mr-3">Data ostatniego wysłania:</strong> {{viewData.latestSendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<h3 class="mt-4 mb-4 ml-4">Elementy opinii końcowej</h3>

		<v-layout row wrap class="mt-4 evaluation-card evaluation-font-size">
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Indywidualna opinia merytoryczna</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.substantive.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.substantive" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>{{item.author}}
									<v-btn icon @click="openEvaluationView(item, 'substantive')" class="no-print">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div v-if="item.evaluationStatus === 'FINISHED'">
									<div v-if="item.evaluation === 'false' || item.evaluation === 'true'">
										Rekomendacja:
										<span v-if="item.evaluation === 'true'" style="color:green; font-weight: bold">TAK</span>
										<span v-else style="color:red; font-weight: bold">NIE</span>
									</div>
									<div v-else>
										Ocena punktowa:
										<span style="color:blue; font-weight: bold">{{item.evaluation}}</span>
									</div>
								</div>
								<div v-else>
									<span
										style="font-style: italic">{{agencyEvaluationStatus(item.evaluationStatus)}}</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia eksperta</strong>
				</v-layout>
				<v-layout>
					<div v-if="evaluation.expert.length === 0" class="ma-4 not-evaluation"
						style="color:blue; font-weight: bold; font-style: italic">BRAK
					</div>
					<div v-else>
						<ul v-for="(item, index) in evaluation.expert" :key="item.evaluation+'-'+index">
							<li class="ma-2">
								<span>{{item.author}}
									<v-btn icon @click="openEvaluationView(item, 'expert')" class="no-print">
										<v-icon title="Podgląd" color="amber">description</v-icon>
									</v-btn>
								</span>
								<div v-if="item.evaluationStatus === 'FINISHED'">
									<div>Rekomendacja:
										<span v-if="item.evaluation==='true'"
											style="color:green; font-weight: bold">TAK</span>
										<span v-else style="color:red; font-weight: bold">NIE</span>
									</div>
								</div>
								<div v-else>
									<span
										style="font-style: italic">{{agencyEvaluationStatus(item.evaluationStatus)}}</span>
								</div>
							</li>
						</ul>
					</div>
				</v-layout>
			</v-flex>
			<v-flex xs4 class="evaluation-component">
				<v-layout row>
					<strong style="height: 50px">Opinia zespołu</strong>
				</v-layout>
				<v-layout align-center>
					<ul>
						<li class="ma-2">
							<span>Ocena zbiorcza
								<v-btn icon @click="openEvaluationSummaryView" class="no-print">
									<v-icon title="Podgląd" color="primary">description</v-icon>
								</v-btn>
							</span>
						</li>
					</ul>
				</v-layout>
			</v-flex>
		</v-layout>

		<div class="mt-3 mb-3">
			<vue-form-generator
				name="generator"
				ref="vfg"
				:model="evaluationData.model"
				:options="formGenerator.formOptions"
				:schema="formGenerator.currentSchema"
				v-if="viewData.showGenerator">
			</vue-form-generator>
		</div>

		<hr class="ma-4">

		<v-form>
			<div style="page-break-inside: avoid">
				<h3 class="mt-4 mb-4 ml-4">Rekomendacja</h3>
				<v-container>
					<v-layout row class="mb-4 evaluation-recommendation-outer no-print">
						<v-flex xs1/>
						<v-flex xs10 :style="recommendationFrameStyle" class="evaluation-recommendation">
							<v-select
								class="ma-3"
								data-vv-name="recommending"
								data-vv-as="Rekomenduję projekt"
								:error-messages="vErrors.collect('recommending')"
								v-validate="'required'"
								:items="viewData.selectItems"
								:disabled="configuration.disabled"
								item-text="name"
								item-value="value"
								v-model="viewData.recommending"
								label="Rekomenduję projekt *"
								aria-label="recommendation"
								for="agency-project-final-evaluation-form-recommend-project"
								id="agency-project-final-evaluation-form-recommend-project"
							></v-select>
						</v-flex>
					</v-layout>
					<div class="d-none print-only ml-3 header-card-font-size">
						Rekomenduję projekt: <strong
							class="ml-2 header-card-font-size">{{projectRecommendation}}</strong>
					</div>
				</v-container>
			</div>
		</v-form>

		<v-expand-transition v-if="viewData.recommending">
			<div class="no-print">
				<hr class="ma-4">
				<h3 class="mt-4 mb-4 ml-4">Rekomendacja zmiany kwoty</h3>
				<div class="evaluation-card">
					<v-layout row align-center mt-2>
						<v-flex xs5>
							<v-subheader>{{viewData.summaryDonation.recommendationFoundingSet ?
								"W kwocie zmienionej" :
								"W kwocie wnioskowanej (" + formatMoney(viewData.mszFundings) + " " + viewData.currencyCode + ")"}}
							</v-subheader>
						</v-flex>
						<v-switch
							class="no-print"
							:disabled="configuration.disabled"
							v-model="viewData.summaryDonation.recommendationFoundingSet"
							aria-label="label for switch"
						></v-switch>
					</v-layout>
					<v-expand-transition>
						<div v-if="viewData.summaryDonation.recommendationFoundingSet">
							<v-layout row align-center>
								<v-flex xs5>
									<div class="mb-2">
										<v-subheader>Rekomendowana kwota ({{viewData.currencyCode}})</v-subheader>
									</div>
								</v-flex>
								<v-flex xs5>
									<egranty-number-input-field
										data-vv-name="summaryDonation"
										data-vv-as="Rekomendowana kwota"
										:error-messages="vErrors.collect('summaryDonation')"
										v-validate="'required'"
										label="Rekomendowana kwota"
										:disabled="configuration.disabled"
										type="number"
										:suffix="' ' + viewData.currencyCode"
										v-model="viewData.summaryDonation.donation"
										aria-label="label for text"
									/>
								</v-flex>
							</v-layout>
							<v-layout style="page-break-inside: avoid">
								<v-textarea
									browser-autocomplete="off"
									outline
									auto-grow
									data-vv-name="justification"
									data-vv-as="Uzasadnienie zmiany kwoty"
									label="Uzasadnienie zmiany kwoty"
									v-model="viewData.summaryDonation.justification"
									:error-messages="vErrors.collect('justification')"
									v-validate="'required|min:10'"
									:disabled="configuration.disabled"
									aria-label="summary donation change justification">
								</v-textarea>
							</v-layout>
						</div>
					</v-expand-transition>
				</div>
			</div>
		</v-expand-transition>

		<div v-if="viewData.recommending" class="d-none print-only">
			<hr class="ma-4">
			<h3 class="mt-4 mb-4 ml-4">Rekomendacja zmiany kwoty</h3>
			<div>
				<div class="mt-3 ml-3 header-card-font-size" v-if="viewData.summaryDonation.recommendationFoundingSet">W
					kwocie
					zmienionej
				</div>
				<div class="mt-3 ml-3 header-card-font-size" v-else>
					W kwocie wnioskowanej: <strong class="ml-2 header-card-font-size">{{formatMoney(viewData.mszFundings)
						+ " " + viewData.currencyCode}}</strong>
				</div>
				<div class="mt-3 ml-3 header-card-font-size" v-if="viewData.summaryDonation.recommendationFoundingSet">
					Rekomendowana kwota: <strong class="ml-2 header-card-font-size">
						{{formatMoney(viewData.summaryDonation.donation) + " " + viewData.currencyCode}}</strong>
					<v-layout style="page-break-inside: avoid">
						<div class="mt-3 header-card-font-size">Uzasadnienie zmiany kwoty:
							<div class="div-for-print mt-3 header-card-font-size"
								style="color: black; width: 89vw">{{viewData.summaryDonation.justification}}
							</div>
						</div>
					</v-layout>
				</div>
			</div>
		</div>

		<hr class="ma-4">

		<div style="page-break-inside: avoid">
			<h3 class="mt-4 mb-4 ml-4 information-meeting-heading">Informacje o posiedzeniu</h3>
			<div class="evaluation-card information-meeting evaluation-font-size">
				<v-layout row wrap>
					<v-flex xs6>
						<v-layout row>
							<v-flex xs4 mt-4>
								<strong>Prowadzący posiedzenie</strong>
							</v-flex>
							<v-flex xs6 ml-4>
								<v-select
									style="font-size: 11pt;"
									data-vv-validate-on="none"
									data-vv-name="conferenceLeader"
									data-vv-as="Prowadzący posiedzenie"
									:error-messages="vErrors.collect('conferenceLeader')"
									v-validate="'required'"
									v-model="viewData.conferenceLeader"
									:items="viewData.conferenceMembers"
									:disabled="configuration.disabled"
									item-text="fullName"
									item-value="id"
									aria-label="conference leader"
									return-object>
								</v-select>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs6>
						<v-layout row>
							<v-flex xs4 mt-4>
								<strong>Osoba protokołująca</strong>
							</v-flex>
							<v-flex xs6 ml-4>
								<v-text-field
									class="no-print"
									browser-autocomplete="off"
									style="font-size: 11pt;"
									readonly
									:disabled="configuration.disabled"
									v-model="viewData.author"
									aria-label="author">
								</v-text-field>
							</v-flex>
							<v-select
								class="d-none print-only"
								style="font-size: 11pt;"
								:disabled="configuration.disabled"
								v-model="viewData.author"
								:items="[viewData.author]"
								return-object>
							</v-select>
						</v-layout>
					</v-flex>
				</v-layout>

				<v-layout row wrap>
					<v-flex xs6>
						<v-layout row>
							<v-flex xs4 mt-4>
								<strong>Uczestnicy</strong>
							</v-flex>
							<v-flex xs6 ml-4>
								<div v-if="viewData.conferenceMembers !== null" class="ma-2 mt-4">
									<ul v-for="member in viewData.conferenceMembers" :key="member.id">
										<li>{{member.fullName}}</li>
									</ul>
								</div>
								<div v-else class="ma-4 not-evaluation"
									style="color:blue; font-weight: bold; font-style: italic">BRAK
								</div>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs6>
						<v-layout row>
							<v-flex xs4 mt-4>
								<strong>Data posiedzenia</strong>
							</v-flex>
							<v-flex xs6 ml-4>
								<v-menu
									ref="conferenceDateMenu"
									v-model="conferenceDateMenu"
									:close-on-content-click="false"
									:nudge-right="40"
									:return-value.sync="viewData.conferenceDate"
									lazy
									transition="scale-transition"
									offset-y
									full-width
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											browser-autocomplete="off"
											data-vv-validate-on="none"
											data-vv-name="conferenceDate"
											data-vv-as="Data posiedzenia"
											:error-messages="vErrors.collect('conferenceDate')"
											v-validate="'required'"
											style="font-size: 11pt;"
											v-model="viewData.conferenceDate"
											append-icon="event"
											:disabled="configuration.disabled"
											readonly
											v-on="on"
											aria-label="conference date"
										></v-text-field>
									</template>
									<v-date-picker :first-day-of-week="1"
										v-model="viewData.conferenceDate" no-title scrollable locale="pl-PL">
										<v-spacer></v-spacer>
										<v-btn flat color="primary" @click="conferenceDateMenu = false">Powrót</v-btn>
										<v-btn flat color="primary"
											@click="$refs.conferenceDateMenu.save(viewData.conferenceDate)">OK
										</v-btn>
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</div>
		</div>

		<v-btn @click="validateAndShowDialog" v-if="!configuration.disabled"
			color="success"
			class="no-print">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>

		<v-btn @click="saveEvaluation" v-if="!configuration.disabled" color="info" class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz ocenę
		</v-btn>

		<evaluation-confirmation-dialog :action="send" :dialog-model="viewData.sendEvaluationDialog"
			@close-confirmation="viewData.sendEvaluationDialog = false"
			action-label="Wyślij" content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz ocenę.
				Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka oceny" icon="send"/>
	</v-container>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Api} from "@/api";
	import {AgencyFinalEvaluation} from "@/api/generated/AgencyFinalEvaluation";
	import {AgencyContestEvaluation} from "@/api/generated/AgencyContestEvaluation";
	import EvaluationConfirmationDialog from "../../EvaluationConfirmationDialog";
	import {Numbers} from "@/utils/Numbers";
	import EgrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {AgencyContest} from "@/api/generated/AgencyContest";
	import {Files} from "@/utils/Files";

	export default {
		name: "AgencyProjectFinalEvaluationForm",
		components: {EvaluationConfirmationDialog, EgrantyNumberInputField},
		data () {
			return {

				configuration: {
					form: "",
					disabled: false
				},

				evaluationData: {
					model: undefined
				},

				viewData: {
					showGenerator: false,
					agencyId: '',
					agencyProjectId: '',
					agencyProjectTitle: '',
					agencyProjectCode: '',
					controlSum: '',
					mszFundings: '',
					currencyCode: '',
					country: '',
					author: '',
					teamId: '',
          firstSendDate: '',
          latestSendDate: '',
					recommending: undefined,
					summaryDonation: {
						recommendationFoundingSet: false,
						donation: null,
						justification: ''
					},
					extraCountries: [],
					conferenceDate: '',
					conferenceLeader: '',
					conferenceMembers: [],
					sendEvaluationDialog: false,
					selectItems: [
						{
							name: "TAK", value: true,
						},
						{
							name: "NIE", value: false,
						},
					]
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: []
				},

				evaluation: {
					substantive: [],
					expert: [],
				},

				contestData: {
					id: this.$route.params.id,
					evaluationOpen: undefined,
					evaluationFinished: undefined
				},

				conferenceDateMenu: false,
			};
		},

		created () {
			this.loadData();
		},

		methods: {
			async loadData () {

				await Api.syncGet(this, "/agency-final-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
					this.formGenerator.currentSchema = genericFormUtil.getSectionSchemaFromSchema(this.configuration.form, 0, this.configuration.disabled);
				});

				AgencyFinalEvaluation.get(this, this.$route.params.evaluationId, success => {
					this.viewData.agencyId = success.agencyId;
					this.viewData.agencyProjectTitle = success.title;
					this.viewData.agencyProjectId = success.agencyProjectId;
					this.viewData.agencyProjectCode = success.agencyProjectCode;
					this.viewData.controlSum = success.controlSum;
					this.viewData.mszFundings = success.mszFundings;
					this.viewData.currencyCode = success.currencyCode;
					this.viewData.author = success.nameSurname;
					this.viewData.teamId = success.teamId;
					this.viewData.country = success.country;
          this.viewData.firstSendDate = success.firstSendDate;
          this.viewData.latestSendDate = success.latestSendDate;
		  			this.viewData.agencyName = success.agencyName;
					this.viewData.recommending = success.evaluationSet ? success.recommending : undefined;
					this.viewData.extraCountries = [];
					success.extraCountries.forEach(country => {
						this.viewData.extraCountries.push(country);
					});

					this.viewData.conferenceDate = success.conferenceDate;
					this.viewData.conferenceLeader = success.conferenceLeader;
					this.viewData.conferenceMembers = success.conferenceMembers;

					this.viewData.summaryDonation.recommendationFoundingSet = success.summaryDonation.recommendationFoundingSet;
					this.viewData.summaryDonation.donation = success.summaryDonation.donation;
					this.viewData.summaryDonation.justification = success.summaryDonation.justification;

					if (success.evaluationStatus === 'FINISHED') {
						this.configuration.disabled = true;
					}
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.applyGenericForm(this.configuration.form);
					this.viewData.showGenerator = true;

					this.getProjectEvaluations(this.viewData.agencyProjectId);
				});

				AgencyContest.getState(this, this.contestData.id,
					response => {
						this.contestData.evaluationOpen = response.agencyContestStatus === 'STARTED';
						this.contestData.evaluationFinished = response.agencyContestStatus === 'FINISHED';
					});
			},

			getProjectEvaluations (agencyProjectId) {
				this.reinitializeEvaluationObject();
				AgencyContestEvaluation.getAgencyProjectEvaluations(this, agencyProjectId, successResponse => {
						successResponse.forEach(item => {
							let index = this.evaluation[item.type.toLowerCase()].findIndex(evaluation => evaluation.id === item.id);
							if (index === -1) {
								this.evaluation[item.type.toLowerCase()].push(item);
							} else {
								this.$set([item.type.toLowerCase()], index, item);
							}
						});
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych ocen", errorResponse);
					});
			},

			reinitializeEvaluationObject () {
				this.evaluation = {
					substantive: [],
					expert: []
				};
			},

			saveEvaluation () {
				AgencyFinalEvaluation.putData(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano ocenę", successResponse);
					this.loadData();
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać oceny", errorResponse);
				});
			},

			async send () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						AgencyFinalEvaluation.putFinish(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
							this.$messagesBus.$emit("success", "Ocena została wysłana", successResponse);
							this.$router.push("/app/agency-evaluations/final");
						}, errorResponse => {
							this.viewData.sendEvaluationDialog = false;
							this.$messagesBus.$emit("error", "Nie udało się wysłać oceny", errorResponse);
						});
					} else {
						this.viewData.sendEvaluationDialog = false;
						this.$messagesBus.$emit("error", this.foundingNotFilled() ?
							"Podaj kwotę rekomendowaną" : "Uzupełnij poprawnie dane oceny");
					}
				});
			},

			prepareFormData () {
				return {
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model),
					evaluationSet: this.viewData.recommending !== undefined,
					recommending: this.viewData.recommending === undefined ? false : this.viewData.recommending,
					conferenceLeaderId: this.viewData.conferenceLeader !== null ? this.viewData.conferenceLeader.id : null,
					conferenceDate: this.viewData.conferenceDate,
					teamId: this.viewData.teamId,
					recommendationFoundingSet: this.viewData.summaryDonation.recommendationFoundingSet,
					donation: this.viewData.summaryDonation.recommendationFoundingSet ?
						this.viewData.summaryDonation.donation : this.viewData.mszFundings,
					justification: this.viewData.summaryDonation.justification
				};
			},

			applyGenericForm (form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async validateAndShowDialog () {
				if (this.contestData.evaluationFinished) {
					this.$messagesBus.$emit("error", "Ocena w naborze została już zakończona");
					return;
				}
				if (!this.allEvaluationsFinished) {
					this.$messagesBus.$emit("error", "Nie wszystkie opinie zostały jeszcze wysłane");
					return;
				}
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (!result) {
						this.$messagesBus.$emit("error", this.foundingNotFilled() ?
							"Podaj kwotę rekomendowaną" : "Uzupełnij wszystkie wymagane pola");
					} else {
						this.viewData.sendEvaluationDialog = true;
					}
				});
			},

			foundingNotFilled () {
				return this.viewData.recommending && this.viewData.summaryDonation.recommendationFoundingSet && 
					(this.viewData.summaryDonation.donation === null || this.viewData.summaryDonation.donation === "");
			},

			openEvaluationSummaryView () {
				this.$router.openInNewTab('/app/agency-contest/' + this.$route.params.id + '/evaluation-summary');
			},

      openProjectView() {
        this.$router.openInNewTab('/view/agency-contest/' + this.$route.params.id + '/project/' + this.viewData.agencyId + '/' + this.viewData.agencyProjectId);
      },

      openEvaluationView(item, evaluationType) {
        this.$router.openInNewTab('/app/agency-contest/' + this.$route.params.id + '/' + evaluationType + '-evaluation/' + item.id);
      },

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getAgencyEvaluationPrintUrl(
						this.$route.params.id,
						"final",
						this.$route.params.evaluationId
					),
					"opinia_końcowa.pdf"
				);
			},

			agencyEvaluationStatus(status) {
				let evaluationStatus = "";
				switch (status) {
					case "NOT_STARTED":
						evaluationStatus = "Nierozpoczęta";
						break;
					case "STARTED":
						evaluationStatus = "Rozpoczęta";
						break;
					case "REVISION":
						evaluationStatus = "Do poprawek";
						break;
				}
				return evaluationStatus;
			}
		},

		mixins: [
			Numbers
		],

		computed: {
			allEvaluationsFinished: function () {
				let allFinished = true;

				this.evaluation.substantive.forEach(evaluation => {
					if (evaluation.evaluationStatus !== 'FINISHED') {
						allFinished = false;
					}
				});
				this.evaluation.expert.forEach(evaluation => {
					if (evaluation.evaluationStatus !== 'FINISHED') {
						allFinished = false;
					}
				});
				return allFinished;
			},

			recommendationFrameStyle () {
				let color = this.viewData.recommending === true ? 'palegreen' :
					this.viewData.recommending === false ? 'palevioletred' : 'lightgray';
				return "border:2px solid " + color + "; border-radius: 25px;";
			},

			projectRecommendation () {
				let found = this.viewData.selectItems.find(item => item.value === this.viewData.recommending);
				if (!found) return "";
				return found.name;
			}
		}
	};
</script>
